import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { getDataFromResolver } from '../../services/resolvers';
import { Resolvers } from '../../types/Resolvers';
import { Sucursal } from '../../types/stores';
import { ApiMembresiaResponse } from '../../types/API.types';

@Component({
  selector: 'allas-nuestras-sucursales',
  template: `
    <section class="w-full max-w-7xl mx-auto p-6 md:p-12 lg:p-10">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        @for (sucursal of sucursales; track sucursal.id) {
        <article
          class="bg-white overflow-hidden hover:shadow-xl transition-shadow duration-300 border-2 border-gray-400"
        >
          <div class="relative">
            <img
              src="/images/stores/{{ sucursal.id_image }}"
              alt="{{ sucursal.name }} - {{ sucursal.address }}"
              class="w-full h-64 object-cover"
            />
          </div>

          <div class="bg-[#003e89] text-white p-4">
            <h3
              class="text-base xl:text-lg font-bold fs-condensed text-center italic uppercase"
            >
              ALLAS REPUESTOS, {{ sucursal.name }}
            </h3>
          </div>

          <div class="p-2 bg-white text-center">
            <p class="text-sm mb-1 ">
              {{ sucursal.address }}
            </p>
            <p class="text-sm mb-2 ">
              {{ sucursal.city }}
            </p>
            <p class="text-sm font-medium">Lun-Vie: 8AM-5PM | Sáb: 8AM-3PM</p>
          </div>
        </article>
        } @empty {
        <div class="text-center text-gray-500 py-12">
          <div class="text-6xl mb-4">🏪</div>
          <p class="text-xl font-medium">No hay sucursales disponibles</p>
        </div>
        }
      </div>
    </section>
  `,
})
export class NuestrasSucursales {
  route = inject(ActivatedRoute);

  sucursales =
    getDataFromResolver<ApiMembresiaResponse<Sucursal[]>>(
      Resolvers.STORES,
      this.route
    ).data || [];
}
